import React from 'react';
import styled from '@emotion/styled';

const Section = styled.section`
  padding: 84px 24px;
  background: #ffffff;
  border-bottom: 1px solid #e2e0dc;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
`;

const Title = styled.h2`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 32px;
  font-weight: 700;
  color: #0f1116;
  margin-bottom: 12px;
  letter-spacing: -0.035em;
`;

const Subtitle = styled.p`
  font-family: 'Public Sans', sans-serif;
  font-size: 17px;
  color: #666a72;
  margin-bottom: 30px;
  font-weight: 400;
`;

const LogoGrid = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-bottom: 36px;
  flex-wrap: wrap;
`;

const ClientLogo = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 14px;
  border: 1px solid #e2e0dc;
  background: #ffffff;
  object-fit: cover;
  opacity: 0.88;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(15, 17, 22, 0.06);
  
  &:hover {
    opacity: 1;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(15, 17, 22, 0.1);
  }
`;

const CTAContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

const CTAButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem;
  padding: 0 1.25rem;
  background: var(--smush-cta-primary);
  color: #ffffff;
  text-decoration: none;
  font-family: 'Public Sans', sans-serif;
  font-weight: 600;
  font-size: 0.95rem;
  border-radius: var(--smush-cta-radius);
  transition: background-color 0.2s ease;
  
  &:hover {
    background: var(--smush-cta-primary-hover);
  }
`;

const SecondaryButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem;
  padding: 0 1.25rem;
  background: var(--smush-cta-secondary);
  color: var(--smush-cta-primary);
  text-decoration: none;
  font-family: 'Public Sans', sans-serif;
  font-weight: 600;
  font-size: 0.95rem;
  border-radius: var(--smush-cta-radius);
  border: 1px solid var(--smush-cta-secondary-border);
  transition: background-color 0.2s ease;
  
  &:hover {
    background: var(--smush-cta-secondary-hover);
  }
`;

const Badge = styled.div`
  display: inline-block;
  padding: 6px 16px;
  background: #ffffff;
  border: 1px solid #e2e0dc;
  border-radius: 8px;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: .1em;
  color: #0f1116;
  margin-bottom: 18px;
`;

const SocialProof: React.FC = () => {
  const emailSubject = 'Request for SmushChatFounding Discount';
  const emailBody = `Hi Asif,

I'm interested in founding discount for SmushChat. Would you have any spot left ?

Name: [YourName]
Email: [Your Email]
Website: [Your Website]
Other Details: [Optional]

Best regards,
[Your Name]`;

  const mailtoLink = `mailto:hello@smushlabs.ai?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;

  return (
    <Section>
      <Container>
        <Badge>Currently Onboarding</Badge>
        <Title>Join 6 Handpicked Early Partners</Title>
        <Subtitle>
          We're onboarding pioneering teams to shape the future of AI support. 4 seats remain.
        </Subtitle>

        <LogoGrid>
          {['Favicon-100x100.webp', 'favicon.jpg', 'favicon-32x32.png', 'favicon-32x32 (1).png', 'faviconV2.png', 'background-32x32.webp'].map((logo, i) => (
            <ClientLogo key={i} src={`/Clients/${logo}`} alt={`Partner ${i + 1}`} />
          ))}
        </LogoGrid>

        <CTAContainer>
          <CTAButton href="/get-started">
            Become an Early Partner
          </CTAButton>
          <SecondaryButton href={mailtoLink}>
            Request Founding Discount
          </SecondaryButton>
        </CTAContainer>
      </Container>
    </Section>
  );
};

export default SocialProof;
